import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';
import { TikTokEmbed } from 'react-social-media-embed';

const CarouselContainer = styled.div`
  width: 80%;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 70%;
  }
`;

const Slide = styled.div`
  display: flex;
  justify-content: center;
`;

const TiktokSlide = styled.div`
  width: 250px;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

const Carousel = () => {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
        {
          breakpoint: 480, // Menambahkan breakpoint untuk media screen dengan lebar maksimal 480px
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    };

    return (
        <CarouselContainer>
            <Slider {...settings}>
                <Slide>
                    <TiktokSlide>
                        <TikTokEmbed
                            height={555}
                            retryDelay={5000}
                            url="https://www.tiktok.com/@priskawheny/video/7212925084120435994?is_from_webapp=1&sender_device=pc&web_id=7225319930060719618"
                            width={325}
                        />
                    </TiktokSlide>
                </Slide>
                <Slide>
                    <TiktokSlide>
                        <TikTokEmbed
                            height={555}
                            retryDelay={5000}
                            url="https://www.tiktok.com/@priskawheny/video/7163871973607492890?is_from_webapp=1&sender_device=pc&web_id=7225319930060719618"
                            width={325}
                        />
                    </TiktokSlide>
                </Slide>
                <Slide>
                    <TiktokSlide>
                        <TikTokEmbed
                            height={555}
                            retryDelay={5000}
                            url="https://www.tiktok.com/@priskawheny/video/7163418443050388763?is_from_webapp=1&sender_device=pc&web_id=7225319930060719618"
                            width={325}
                        />
                    </TiktokSlide>
                </Slide>
                <Slide>
                    <TiktokSlide>
                        <TikTokEmbed
                            height={555}
                            retryDelay={5000}
                            url="https://www.tiktok.com/@priskawheny/video/7163632248351165723?is_from_webapp=1&sender_device=pc&web_id=7225319930060719618"
                            width={325}
                        />
                    </TiktokSlide>
                </Slide>
                <Slide>
                    <TiktokSlide>
                        <TikTokEmbed
                            height={555}
                            retryDelay={5000}
                            url="https://www.tiktok.com/@priskawheny/video/7163418443050388763?is_from_webapp=1&sender_device=pc&web_id=7225319930060719618"
                            width={325}
                        />
                    </TiktokSlide>
                </Slide>
                <Slide>
                    <TiktokSlide>
                        <TikTokEmbed
                            height={555}
                            retryDelay={5000}
                            url="https://www.tiktok.com/@priskawheny/video/7163414759100976411?is_from_webapp=1&sender_device=pc&web_id=7225319930060719618"
                            width={325}
                        />
                    </TiktokSlide>
                </Slide>
            </Slider>
        </CarouselContainer>
    );
};

export default Carousel;
